var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6825 8.33999C15.6825 12.0075 13.02 15.4425 9.38251 16.4475C9.13501 16.515 8.86499 16.515 8.61749 16.4475C4.97999 15.4425 2.3175 12.0075 2.3175 8.33999V5.04748C2.3175 4.43248 2.78251 3.73498 3.36001 3.50248L7.53749 1.79251C8.47499 1.41001 9.53249 1.41001 10.47 1.79251L14.6475 3.50248C15.2175 3.73498 15.69 4.43248 15.69 5.04748L15.6825 8.33999Z",
    stroke: "#737885",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0,
    d: "M0.5 17.5L0.5 0.5L17.5 0.5L17.5 17.5L0.5 17.5Z",
    stroke: "#737885"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.aef02ce8005c40684c774cc55e9f193a.svg";
export { ForwardRef as ReactComponent };